import { TeamSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const TEAM_TABLE = '"public"."teams"'

export const TeamConfig: CollectionBuildRequestConfig = {
  collectionType: 'query',
  table: TEAM_TABLE,
  partitionKey: 'workspace_slug',
  key: 'id',
  apiEndpoint: '/api/team',
  where: {},
  schema: TeamSchema,
}
